<template>
	<!-- 导航跳转有bug -->
	<div class="case_wrap">
		<el-container>
			<el-aside v-if="!isExportRecordsPage" width="250px">
				<el-menu default-active="ComAwait" router>
					<p @click="pathFun" class="b_index">返回首页</p>
          <!-- 其他 -->
					<div class="nav_box" v-if="typeId == 600" >
						<a class="up">星使派单</a>
						<!--<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">星使派单</router-link>-->
						<router-link v-if='insti.type != 5' class="ha" :to="{name:'newstar',params:{token:token},query:{typeId:typeId}}">新建星使派单</router-link>
						<a v-if='insti.type != 5' class="up">星使派单处理</a>
						<router-link v-if='insti.type != 1' class="ha" :class='{active:routerShow1}' :to="{name:'shenhezhongList',params:{token:token},query:{typeId:typeId}}">审核中的案件</router-link>
						<router-link class="ha" :class='{active:routerShow2}'  :to="{name:'underway',params:{token:token},query:{typeId:typeId}}">进行中的案件</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'starcompleted',params:{token:token},query:{typeId:typeId}}">已完成的案件</router-link>
						<router-link v-if='insti.type != 1' class="ha" :class='{active:routerShow4}' :to="{name:'refusedstar',params:{token:token},query:{typeId:typeId}}">拒绝启动的案件</router-link>
						<router-link class="ha" :class='{active:routerShow5}' :to="{name:'caserecord',params:{token:token},query:{typeId:typeId}}">案件记录</router-link>
						<a class="up">协调员管理</a>
						<router-link class="ha" :to="{name:'addcoordinator',params:{token:token},query:{typeId:typeId}}">添加国内协调员</router-link>
						<router-link class="ha" :to="{name:'coordinatorlist',params:{token:token},query:{typeId:typeId}}">国内协调员列表</router-link>
					</div>
            <!-- 家财险 -->
          	<div class="nav_box" v-else-if="typeId == 800" >
						<a class="up">家财服务</a>
						<!--<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">星使派单</router-link>-->
						<router-link  class="ha" :to="{name:'Familywealth',params:{token:token},query:{typeId:typeId}}">创立案件</router-link>
						<!-- <a v-if='insti.type != 5' class="up">星使派单处理</a> -->
            	<router-link  class="ha" :class='{active:routerShow4}' :to="{name:'Homestart4',params:{token:token},query:{typeId:typeId}}">全部案件管理</router-link>
            	<router-link  class="ha" :class='{active:routerShow6}' :to="{name:'Homestart2',params:{token:token},query:{typeId:typeId}}">未启动救援案件管理</router-link>
						<router-link  class="ha" :class='{active:routerShow1}' :to="{name:'Homestart',params:{token:token},query:{typeId:typeId}}">已启动救援案件管理</router-link>
            <router-link class="ha" :class='{active:routerShow5}'  :to="{name:'Homestart3',params:{token:token},query:{typeId:typeId}}">救援完成待确认</router-link>
						<router-link class="ha" :class='{active:routerShow2}'  :to="{name:'Homestart1',params:{token:token},query:{typeId:typeId}}">已完成救援案件管理</router-link>
            <router-link class="ha" :class='{active:routerShow10}'  :to="{name:'draft',params:{token:token},query:{typeId:typeId}}">草稿列表</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'Insurancemanagement',params:{token:token},query:{typeId:typeId}}">保险机构管理</router-link>
					
					</div>
           <!-- 救援 -->
           <div class="nav_box" v-else-if="typeId == 900" >
						<a class="up">救援案件</a>
						<router-link  class="ha" :to="{name:'createRescue',params:{token:token},query:{typeId:typeId}}">创建案件</router-link>
            <a class="up">案件管理</a>
            <router-link  class="ha" :class='{active:routerShow7}' :to="{name:'rescueList5',params:{token:token},query:{typeId:typeId,type:6}}">全部案件</router-link>
            	<router-link  class="ha" :class='{active:routerShow6}' :to="{name:'rescueList',params:{token:token},query:{typeId:typeId,type:0}}">待处理案件</router-link>
            	<router-link  class="ha" :class='{active:routerShow4}' :to="{name:'rescueList2',params:{token:token},query:{typeId:typeId,type:1}}">救援中案件</router-link>
						<router-link  class="ha" :class='{active:routerShow1}' :to="{name:'rescueList3',params:{token:token},query:{typeId:typeId,type:2}}">已完成案件</router-link>
            <router-link class="ha" :class='{active:routerShow5}'  :to="{name:'rescueList4',params:{token:token},query:{typeId:typeId,type:3}}">已取消案件</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'Insurancemanagement',params:{token:token},query:{typeId:typeId}}">保险机构管理</router-link>
					</div>
          <div class="nav_box" v-else>
						<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">{{typeName}}</router-link>
						<!-- <router-link :to="{name:'ComIndex',params:{token:token,insti:insti}}" class="b_index">返回首页</router-link> -->
						<router-link class="ha" :to="{name:'appcase',params:{token:token},query:{typeId:typeId}}">创建案件</router-link>
						<router-link class="up" :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">{{typeName}}管理</router-link>
						<router-link class="ha" :class='{active:routerShow1 || routerShow5}' :to="{name:'ComAwait',params:{token:token},query:{typeId:typeId}}">未启动救援案件列表</router-link>
						<router-link class="ha" :class='{active:routerShow2 || routerShow6 || routerShow7}'  :to="{name:'ComOffer',params:{token:token},query:{typeId:typeId}}">已启动救援案件管理</router-link>
						<router-link class="ha" :class='{active:routerShow4}' :to="{name:'ComRescue',params:{token:token},query:{typeId:typeId}}">救援中案件管理</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'finishSure',params:{token:token},query:{typeId:typeId}}">救援完成待确认</router-link>
						<router-link class="ha" :class='{active:routerShow8}' :to="{name:'finishEnd',params:{token:token},query:{typeId:typeId}}">已完成案件</router-link>
						<router-link class="ha" :class='{active:routerShow9}' :to="{name:'ComAwait1',params:{token:token},query:{typeId:typeId}}">报价被拒案件</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main :class="{ 'full-width': isExportRecordsPage }">
				<router-view></router-view>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	export default {
		data() {
			return {
				token:JSON.parse(window.localStorage.getItem("data")).data,
				insti:JSON.parse(window.localStorage.getItem("insti")),
				typeId: this.$route.query.typeId,
				typeName: "",
				routerShow1:false,
				routerShow2:false,
				routerShow3:false,
				routerShow4:false,
				routerShow5:false,
        routerShow6:false,
        routerShow7:false,
        routerShow10:false
			};
		},
		computed: {
			/**
			 * 判断当前是否为导出记录页面
			 * @returns {boolean} 是否为导出记录页面
			 */
			isExportRecordsPage() {
				return this.$route.name === 'Exportrecords';
			}
		},
		methods: {
			back() {},
			pathFun(){
        if(this.insti.type == 1){
          this.$router.push({path:'/cmd_center/'})
        }else{
          this.$router.push({path:'/branch/'})
        }

			},
			routerFun(to){
        console.log(to)
				var router=to.name;
				if(router == 'shenhezhongList'){
					this.routerShow1=true;
				} else if(router == 'underway' ){
					this.routerShow2=true;
				}else if(router == 'starcompleted'){
					this.routerShow3=true;
				}else if(router == 'refusedstar'){
					this.routerShow4=true;
				}else if(router == 'caserecord'){
					this.routerShow5=true;
				}
			},
		},
		mounted() {
			this.routerFun(this.$route)
		},
		updated() {
			this.typeId = this.$route.query.typeId;
		},
		watch:{
			$route(from,to){
        console.log(from);
        this.routerShow1=false;
        this.routerShow2=false;
        this.routerShow3=false;
        this.routerShow4=false;
        this.routerShow5=false;
       
        if(from.name == 'starsdetail'){
          this.routerFun(to)
        }
			}
		}
	};
</script>

<style scoped>
	@import url(../../../css/caseindex.css);
	.active{background: #00abfa;color: #fff;}
	.router-link-active:hover,
	.active:hover {
		color: #fff;
		background: #00abfa
	}
	
	/**
	 * 当隐藏左侧导航栏时，主内容区域占满全宽
	 */
	.full-width {
		margin-left: 0 !important;
		width: 100% !important;
	}

</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/Starindex.vue